import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SanitizeHtmlPipe } from './pipes/sanitize-html.pipe';
import { SanitizeUrlPipe } from './pipes/sanitize-url.pipe';
import { TruncateTextPipe } from './pipes/truncate-text.pipe';
import { EvenOddPipe } from './pipes/odd-even.pipe';
import { LinkifyImagePipe } from './pipes/linkify-image.pipe';
import { RunScriptDirective } from './directives/run-script.directive';

@NgModule({
  imports: [CommonModule],
  exports: [
    SanitizeHtmlPipe,
    SanitizeUrlPipe,
    TruncateTextPipe,
    EvenOddPipe,
    LinkifyImagePipe,
    RunScriptDirective,
  ],
  declarations: [
    SanitizeHtmlPipe,
    SanitizeUrlPipe,
    TruncateTextPipe,
    EvenOddPipe,
    LinkifyImagePipe,
    RunScriptDirective,
  ],
})
export class UtilsModule {}
